import { render, staticRenderFns } from "./ListCentroDeCustoView.vue?vue&type=template&id=47efbc18&"
import script from "./ListCentroDeCustoView.vue?vue&type=script&lang=ts&"
export * from "./ListCentroDeCustoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports